
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexMQGWGIuclvvt4GqIC_45mQ64zrqgbugCiVeLXStOXlFlIMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/index.vue?macro=true";
import { default as astucesywnESgXMjD6NdjWSikETAxwSVmWU2jOb0B29SFUxKpsMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/astuces.vue?macro=true";
import { default as landinghbvbJOuwZBOLqJoxG9bwZVyRYLwXXC9fo07YRFztyKgMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/landing.vue?macro=true";
import { default as astrobotmPqW1hiPqGzBPID5fCN_oVRCUrWQ1mbaMGjDuvWVjFAMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/astrobot.vue?macro=true";
import { default as avantagesoK_2ambovruUblcuHQzMi8jJjm9hEODUY53USpcaXoAMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/avantages.vue?macro=true";
import { default as recherchen5XLLFD4zrnZQgWrQIBpT86omat9kFOjuuNFonIC35gMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/recherche.vue?macro=true";
import { default as challengeszlLrXsuJ4ZNJN4RxBXjNYrcgeoFI1jTw5v8heHr8QyoMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/challenges.vue?macro=true";
import { default as mon_45profilTymCxBgXvUqSdr2GOAdxq7nUGvil_45wbMve_OaCF2iokMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/mon-profil.vue?macro=true";
import { default as avis_45medias1_NuQ7z79eUjrYWlSIGMWv6PDiQNk9cf09LqOW_u6HsMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/avis-medias.vue?macro=true";
import { default as inscriptionomg9A_45OaORiPUdNYZBXvXd2zLWdrt2K_45f3Sjcg_45itNkMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/inscription.vue?macro=true";
import { default as avis_45joueurspohtsewpHnT4IY_X_ncPbUHTCi8a02BhKW2ExdXl8E8Meta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/avis-joueurs.vue?macro=true";
import { default as indexAhhG3sgIfgNutf7D8w8Znge0QFmx4G7Wmlm9MtLCACEMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/offres/index.vue?macro=true";
import { default as indexPNab6DX3iqGAm4_45xVIcg_45AyWkJcIJaXQd1LAY27OW3wMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/wapers/index.vue?macro=true";
import { default as indexZK_AgFoMvynEIsJBm0nPvyRyhvhgi4ZTdkc0FcFbnpIMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/concours/index.vue?macro=true";
import { default as _91pageName_937VyKq1WVn7lvlz6p9dVBCAt__45CdaMwYUbO71C3IwzFsMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/page/[pageName].vue?macro=true";
import { default as indexsCpvwV6KcPiexlHDkzveZRtjZbdMLIKajjPgfl6zg0UMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/index.vue?macro=true";
import { default as _91nickname_9341m58OkpC9ZR_OErmwbzsbXwGY6dMgq3kTa8kN4mCWYMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/wapers/[nickname].vue?macro=true";
import { default as _91offerName_93y3U0Ddzla_45kuYN9uihU5KxtURadgi8tVUao7_FCsyJgMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/offres/[offerName].vue?macro=true";
import { default as le_45feed_45des_45playersak91U5lWXBA8pkJToVJ2yr5N7_45kfuKNaqU4MyUbRXdUMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/le-feed-des-players.vue?macro=true";
import { default as actualites_45communautes_45I9PZJ24KxG_45HidiOq5bLO8bL6lDtKNOGzkVueupJ7AMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-communautes.vue?macro=true";
import { default as _91contestName_93wRIGpNYCW1QhD1YUpPipZywQmcNZS0pTZzBLzzdhPaAMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/concours/[contestName].vue?macro=true";
import { default as _91tournamentName_93BZ1dVyc4oW3wfo_45oq5hxMPWI6SGSFhqxHA0_zVB7x48Meta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/tournoi/[tournamentName].vue?macro=true";
import { default as _91challengeName_93xsqjkQm_45p06o8LCNXru3bMRmgpGxhjNt93tbA_Rl2e4Meta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/challenge/[challengeName].vue?macro=true";
import { default as _91contestName_93fYhf_G2kKIkKk4ozUMdnigJ1E5Yr8KlB0QP_Zq4xKxsMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/jeu-concours/[contestName].vue?macro=true";
import { default as _91typeName_93i6tE59fwJ7l9rPhBbJqhHF2q7Uui0jYf2ZWEACn5kX4Meta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/type/[typeName].vue?macro=true";
import { default as indexQMR1j1hq6Je65a6wU8pqJh_Ynmzr2n6wHpLLvpUuZ10Meta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-playstation/index.vue?macro=true";
import { default as _91title_934sVjl5QmU_Fyn0gfcQcMW9H36DJWUIBWlJNqPl4V_4UMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-playstation/[title].vue?macro=true";
import { default as _91genderName_93Ae_453AX3KIv_Xn3Nm_La8rxblAF7BHk8U4jLdLTAmL5QMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/genre/[genderName].vue?macro=true";
import { default as indexby0iQBeuy__45FqRcYMpBXEQ7BIHEaRMM9VuBLcUmjeAEMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/index.vue?macro=true";
import { default as _91contestName_93Dixk_457QXGAn8upKwRATtuIY70El_45VlRdWz3aiKIzOY0Meta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/concours-classement/[contestName].vue?macro=true";
import { default as indexQrEpY_uQf962pGAZGGMv5oNSblW_TC4WB2Q3Y7twnwEMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/wapers/index.vue?macro=true";
import { default as index2fg1LNFg5bmhngd0HN3DPHFOk0IlBHGP5SPMS_CXAlIMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/astuces/index.vue?macro=true";
import { default as concours_45stellar_45bladeES3KOvfw4OowI16A7ttFJIiux7Zk9qT8mj_bg0A3TEIMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-playstation/concours-stellar-blade.vue?macro=true";
import { default as indexbkXK65Bs5dcd0zBpLGFhfQV_J4Hj5uNGouTbfRO4zVMMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/index.vue?macro=true";
import { default as indexUjIY0nuxugo1euoytvD7jpOoxgwb32geD0LOFDg1DfYMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/index.vue?macro=true";
import { default as _91postTitle_93AOoUPoH_Q8CRXy9V1Hk7KYrU2Bpyn9V1UudeOhM1DKIMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/[postTitle].vue?macro=true";
import { default as indexUsUCbSft_YF3fWiLRMU5TgdT9KMJKb0Ec2Mh9_45XNpzoMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/index.vue?macro=true";
import { default as indexUIS04tEMRx1Y7IAWwA_486Mr3etzXejQIrfAYuRng8QMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/index.vue?macro=true";
import { default as indexvH8krsIVMqyvG4UvvlU3_qbOE2W154W_HXe4cGoA4eUMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/index.vue?macro=true";
import { default as _91postTitle_93rim53GR1_d9OemR7TZ9cWNtc4hXDIStijnKL8IHTGdMMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/detail/[postTitle].vue?macro=true";
import { default as _91postTitle_930bkzhUg0ZILb9gH2c7HhzJssYU3SYz43N_nV9Q9LGaoMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/[postTitle].vue?macro=true";
import { default as _91postTitle_93EXRZ8WxKMfjOKEn28wCUOEDbkYRHKBmzd2lgRk0P_45QoMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/[postTitle].vue?macro=true";
import { default as indexgHmIJ_45RJSctoB5tWFF_fI7hSWZuKkIdqbE4Ma2ISQ8YMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/index.vue?macro=true";
import { default as _91postTitle_93g0VlQqVFShi0lmDRqATb1Q1t95iyVX16aENijiuYZSoMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/[postTitle].vue?macro=true";
import { default as component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnAMeta } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.14.9_@vue+compiler-sfc@3.5.44_cac@6.7._4nw34muufof73viqpe4o44xswm/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnA } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.14.9_@vue+compiler-sfc@3.5.44_cac@6.7._4nw34muufof73viqpe4o44xswm/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/index.vue")
  },
  {
    name: "astuces",
    path: "/astuces",
    meta: astucesywnESgXMjD6NdjWSikETAxwSVmWU2jOb0B29SFUxKpsMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/astuces.vue")
  },
  {
    name: "landing",
    path: "/landing",
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/landing.vue")
  },
  {
    name: "astrobot",
    path: "/astrobot",
    meta: astrobotmPqW1hiPqGzBPID5fCN_oVRCUrWQ1mbaMGjDuvWVjFAMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/astrobot.vue")
  },
  {
    name: "avantages",
    path: "/avantages",
    meta: avantagesoK_2ambovruUblcuHQzMi8jJjm9hEODUY53USpcaXoAMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/avantages.vue")
  },
  {
    name: "recherche",
    path: "/recherche",
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/recherche.vue")
  },
  {
    name: "challenges",
    path: "/challenges",
    meta: challengeszlLrXsuJ4ZNJN4RxBXjNYrcgeoFI1jTw5v8heHr8QyoMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/challenges.vue")
  },
  {
    name: "mon-profil",
    path: "/mon-profil",
    meta: {"middleware":["temp-auth"]},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/mon-profil.vue")
  },
  {
    name: "avis-medias",
    path: "/avis-medias",
    meta: avis_45medias1_NuQ7z79eUjrYWlSIGMWv6PDiQNk9cf09LqOW_u6HsMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/avis-medias.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/inscription.vue")
  },
  {
    name: "avis-joueurs",
    path: "/avis-joueurs",
    meta: avis_45joueurspohtsewpHnT4IY_X_ncPbUHTCi8a02BhKW2ExdXl8E8Meta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/avis-joueurs.vue")
  },
  {
    name: "offres",
    path: "/offres",
    meta: indexAhhG3sgIfgNutf7D8w8Znge0QFmx4G7Wmlm9MtLCACEMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/offres/index.vue")
  },
  {
    name: "wapers",
    path: "/wapers",
    meta: indexPNab6DX3iqGAm4_45xVIcg_45AyWkJcIJaXQd1LAY27OW3wMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/wapers/index.vue")
  },
  {
    name: "concours",
    path: "/concours",
    meta: indexZK_AgFoMvynEIsJBm0nPvyRyhvhgi4ZTdkc0FcFbnpIMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/concours/index.vue")
  },
  {
    name: "page-pageName",
    path: "/page/:pageName()",
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/page/[pageName].vue")
  },
  {
    name: "communautes",
    path: "/communautes",
    meta: indexsCpvwV6KcPiexlHDkzveZRtjZbdMLIKajjPgfl6zg0UMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/index.vue")
  },
  {
    name: "wapers-nickname",
    path: "/wapers/:nickname()",
    meta: _91nickname_9341m58OkpC9ZR_OErmwbzsbXwGY6dMgq3kTa8kN4mCWYMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/wapers/[nickname].vue")
  },
  {
    name: "offres-offerName",
    path: "/offres/:offerName()",
    meta: _91offerName_93y3U0Ddzla_45kuYN9uihU5KxtURadgi8tVUao7_FCsyJgMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/offres/[offerName].vue")
  },
  {
    name: "le-feed-des-players",
    path: "/le-feed-des-players",
    meta: le_45feed_45des_45playersak91U5lWXBA8pkJToVJ2yr5N7_45kfuKNaqU4MyUbRXdUMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/le-feed-des-players.vue")
  },
  {
    name: "actualites-communautes",
    path: "/actualites-communautes",
    meta: actualites_45communautes_45I9PZJ24KxG_45HidiOq5bLO8bL6lDtKNOGzkVueupJ7AMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-communautes.vue")
  },
  {
    name: "concours-contestName",
    path: "/concours/:contestName()",
    meta: _91contestName_93wRIGpNYCW1QhD1YUpPipZywQmcNZS0pTZzBLzzdhPaAMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/concours/[contestName].vue")
  },
  {
    name: "tournoi-tournamentName",
    path: "/tournoi/:tournamentName()",
    meta: _91tournamentName_93BZ1dVyc4oW3wfo_45oq5hxMPWI6SGSFhqxHA0_zVB7x48Meta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/tournoi/[tournamentName].vue")
  },
  {
    name: "challenge-challengeName",
    path: "/challenge/:challengeName()",
    meta: _91challengeName_93xsqjkQm_45p06o8LCNXru3bMRmgpGxhjNt93tbA_Rl2e4Meta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/challenge/[challengeName].vue")
  },
  {
    name: "jeu-concours-contestName",
    path: "/jeu-concours/:contestName()",
    meta: _91contestName_93fYhf_G2kKIkKk4ozUMdnigJ1E5Yr8KlB0QP_Zq4xKxsMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/jeu-concours/[contestName].vue")
  },
  {
    name: "communautes-type-typeName",
    path: "/communautes/type/:typeName()",
    meta: _91typeName_93i6tE59fwJ7l9rPhBbJqhHF2q7Uui0jYf2ZWEACn5kX4Meta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/type/[typeName].vue")
  },
  {
    name: "actualites-playstation",
    path: "/actualites-playstation",
    meta: indexQMR1j1hq6Je65a6wU8pqJh_Ynmzr2n6wHpLLvpUuZ10Meta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-playstation/index.vue")
  },
  {
    name: "actualites-playstation-title",
    path: "/actualites-playstation/:title()",
    meta: _91title_934sVjl5QmU_Fyn0gfcQcMW9H36DJWUIBWlJNqPl4V_4UMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-playstation/[title].vue")
  },
  {
    name: "communautes-genre-genderName",
    path: "/communautes/genre/:genderName()",
    meta: _91genderName_93Ae_453AX3KIv_Xn3Nm_La8rxblAF7BHk8U4jLdLTAmL5QMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/genre/[genderName].vue")
  },
  {
    name: "communautes-communityName",
    path: "/communautes/:communityName()",
    meta: indexby0iQBeuy__45FqRcYMpBXEQ7BIHEaRMM9VuBLcUmjeAEMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/index.vue")
  },
  {
    name: "concours-classement-contestName",
    path: "/concours-classement/:contestName()",
    meta: _91contestName_93Dixk_457QXGAn8upKwRATtuIY70El_45VlRdWz3aiKIzOY0Meta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/concours-classement/[contestName].vue")
  },
  {
    name: "communautes-communityName-wapers",
    path: "/communautes/:communityName()/wapers",
    meta: indexQrEpY_uQf962pGAZGGMv5oNSblW_TC4WB2Q3Y7twnwEMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/wapers/index.vue")
  },
  {
    name: "communautes-communityName-astuces",
    path: "/communautes/:communityName()/astuces",
    meta: index2fg1LNFg5bmhngd0HN3DPHFOk0IlBHGP5SPMS_CXAlIMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/astuces/index.vue")
  },
  {
    name: "actualites-playstation-concours-stellar-blade",
    path: "/actualites-playstation/concours-stellar-blade",
    meta: concours_45stellar_45bladeES3KOvfw4OowI16A7ttFJIiux7Zk9qT8mj_bg0A3TEIMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/actualites-playstation/concours-stellar-blade.vue")
  },
  {
    name: "communautes-communityName-avis-medias",
    path: "/communautes/:communityName()/avis-medias",
    meta: indexbkXK65Bs5dcd0zBpLGFhfQV_J4Hj5uNGouTbfRO4zVMMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/index.vue")
  },
  {
    name: "communautes-communityName-avis-joueurs",
    path: "/communautes/:communityName()/avis-joueurs",
    meta: indexUjIY0nuxugo1euoytvD7jpOoxgwb32geD0LOFDg1DfYMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/index.vue")
  },
  {
    name: "communautes-communityName-avis-medias-postTitle",
    path: "/communautes/:communityName()/avis-medias/:postTitle()",
    meta: _91postTitle_93AOoUPoH_Q8CRXy9V1Hk7KYrU2Bpyn9V1UudeOhM1DKIMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/[postTitle].vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players",
    path: "/communautes/:communityName()/le-feed-des-players",
    meta: indexUsUCbSft_YF3fWiLRMU5TgdT9KMJKb0Ec2Mh9_45XNpzoMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/index.vue")
  },
  {
    name: "communautes-communityName-actualites-communaute",
    path: "/communautes/:communityName()/actualites-communaute",
    meta: indexUIS04tEMRx1Y7IAWwA_486Mr3etzXejQIrfAYuRng8QMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/index.vue")
  },
  {
    name: "communautes-communityName-astuces-subCategoryName",
    path: "/communautes/:communityName()/astuces/:subCategoryName()",
    meta: indexvH8krsIVMqyvG4UvvlU3_qbOE2W154W_HXe4cGoA4eUMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/index.vue")
  },
  {
    name: "communautes-communityName-avis-joueurs-detail-postTitle",
    path: "/communautes/:communityName()/avis-joueurs/detail/:postTitle()",
    meta: _91postTitle_93rim53GR1_d9OemR7TZ9cWNtc4hXDIStijnKL8IHTGdMMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/detail/[postTitle].vue")
  },
  {
    name: "communautes-communityName-actualites-communaute-postTitle",
    path: "/communautes/:communityName()/actualites-communaute/:postTitle()",
    meta: _91postTitle_930bkzhUg0ZILb9gH2c7HhzJssYU3SYz43N_nV9Q9LGaoMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/[postTitle].vue")
  },
  {
    name: "communautes-communityName-astuces-subCategoryName-postTitle",
    path: "/communautes/:communityName()/astuces/:subCategoryName()/:postTitle()",
    meta: _91postTitle_93EXRZ8WxKMfjOKEn28wCUOEDbkYRHKBmzd2lgRk0P_45QoMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/[postTitle].vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players-subCategoryName",
    path: "/communautes/:communityName()/le-feed-des-players/:subCategoryName()",
    meta: indexgHmIJ_45RJSctoB5tWFF_fI7hSWZuKkIdqbE4Ma2ISQ8YMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/index.vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players-subCategoryName-postTitle",
    path: "/communautes/:communityName()/le-feed-des-players/:subCategoryName()/:postTitle()",
    meta: _91postTitle_93g0VlQqVFShi0lmDRqATb1Q1t95iyVX16aENijiuYZSoMeta || {},
    component: () => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/[postTitle].vue")
  },
  {
    name: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnAMeta?.name,
    path: "/le-coin-des-wapers",
    component: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnA
  },
  {
    name: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnAMeta?.name,
    path: "/0-sitemap.xml",
    component: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnA
  },
  {
    name: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnAMeta?.name,
    path: "/1-sitemap.xml",
    component: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnA
  },
  {
    name: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnAMeta?.name,
    path: "/2-sitemap.xml",
    component: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnA
  },
  {
    name: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnAMeta?.name,
    path: "/3-sitemap.xml",
    component: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnA
  },
  {
    name: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubFoD3sLJ256_X9pmR6PNLaKA9aAesPAUmcysI1OUAOnA
  }
]